module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOfferLetter($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reportingmanager),
      expression: "form.reportingmanager"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reportingmanager'),
    },
    attrs: {
      "type": "text",
      "name": "reportingmanager",
      "placeholder": "Reporting Manager"
    },
    domProps: {
      "value": (_vm.form.reportingmanager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reportingmanager", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reportingmanager"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.annualctc),
      expression: "form.annualctc"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('annualctc'),
    },
    attrs: {
      "type": "text",
      "name": "annualctc",
      "placeholder": "Enter Employee annual CTC"
    },
    domProps: {
      "value": (_vm.form.annualctc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "annualctc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "annualctc"
    }
  })], 1)]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(6), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createExperienceletter($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.periodStartDate),
      expression: "form.periodStartDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('periodStartDate'),
    },
    attrs: {
      "type": "date",
      "name": "periodStartDate",
      "placeholder": "Period Start Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.periodStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "periodStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "periodStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.periodEndDate),
      expression: "form.periodEndDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('periodEndDate'),
    },
    attrs: {
      "type": "date",
      "name": "periodEndDate",
      "placeholder": "Period End Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.periodEndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "periodEndDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "periodEndDate"
    }
  })], 1)]), _vm._v(" "), _vm._m(11)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(12), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createRelievingletter($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.resignationDate),
      expression: "form.resignationDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('resignationDate'),
    },
    attrs: {
      "type": "date",
      "name": "resignationDate",
      "placeholder": "Resignation Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.resignationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "resignationDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "resignationDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lastDateOfEmployment),
      expression: "form.lastDateOfEmployment"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('lastDateOfEmployment'),
    },
    attrs: {
      "type": "date",
      "name": "lastDateOfEmployment",
      "placeholder": "Last Day of Employment",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.lastDateOfEmployment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "lastDateOfEmployment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "lastDateOfEmployment"
    }
  })], 1)]), _vm._v(" "), _vm._m(17)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(18), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createConfirmationletter($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.probationPeriodStartDate),
      expression: "form.probationPeriodStartDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('probationPeriodStartDate'),
    },
    attrs: {
      "type": "date",
      "name": "probationPeriodStartDate",
      "placeholder": "Period Start Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.probationPeriodStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "probationPeriodStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "probationPeriodStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.probationPeriodEndDate),
      expression: "form.probationPeriodEndDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('probationPeriodEndDate'),
    },
    attrs: {
      "type": "date",
      "name": "probationPeriodEndDate",
      "placeholder": "Period End Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.probationPeriodEndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "probationPeriodEndDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "probationPeriodEndDate"
    }
  })], 1)]), _vm._v(" "), _vm._m(23)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(24), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createAppointmentLetterPermanent($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reportingmanager),
      expression: "form.reportingmanager"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reportingmanager'),
    },
    attrs: {
      "type": "text",
      "name": "reportingmanager",
      "placeholder": "Reporting Manager"
    },
    domProps: {
      "value": (_vm.form.reportingmanager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reportingmanager", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reportingmanager"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contracttenure),
      expression: "form.contracttenure"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('contracttenure'),
    },
    attrs: {
      "type": "text",
      "name": "contracttenure",
      "placeholder": "Enter Employee Contract Tenure"
    },
    domProps: {
      "value": (_vm.form.contracttenure)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contracttenure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "contracttenure"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.consultancyfees),
      expression: "form.consultancyfees"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('consultancyfees'),
    },
    attrs: {
      "type": "text",
      "name": "consultancyfees",
      "placeholder": "consultancy fees"
    },
    domProps: {
      "value": (_vm.form.consultancyfees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "consultancyfees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "consultancyfees"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(30), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.monthlygrosssalary),
      expression: "form.monthlygrosssalary"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('monthlygrosssalary'),
    },
    attrs: {
      "type": "text",
      "name": "monthlygrosssalary",
      "placeholder": "Monthly Gross Salary"
    },
    domProps: {
      "value": (_vm.form.monthlygrosssalary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "monthlygrosssalary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "monthlygrosssalary"
    }
  })], 1)]), _vm._v(" "), _vm._m(31)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(32), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createAppointmentLetterContract($event)
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(33), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(34), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent"
    },
    on: {
      "input": _vm.getEmployeeDetails
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(35), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reportingmanager),
      expression: "form.reportingmanager"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reportingmanager'),
    },
    attrs: {
      "type": "text",
      "name": "reportingmanager",
      "placeholder": "Reporting Manager"
    },
    domProps: {
      "value": (_vm.form.reportingmanager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reportingmanager", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reportingmanager"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(36), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contracttenure),
      expression: "form.contracttenure"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('contracttenure'),
    },
    attrs: {
      "type": "text",
      "name": "contracttenure",
      "placeholder": "Enter Employee Contract Tenure"
    },
    domProps: {
      "value": (_vm.form.contracttenure)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contracttenure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "contracttenure"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(37), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.consultancyfees),
      expression: "form.consultancyfees"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('consultancyfees'),
    },
    attrs: {
      "type": "text",
      "name": "consultancyfees",
      "placeholder": "consultancy fees"
    },
    domProps: {
      "value": (_vm.form.consultancyfees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "consultancyfees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "consultancyfees"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(38), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.travelfare),
      expression: "form.travelfare"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('travelfare'),
    },
    attrs: {
      "type": "text",
      "name": "travelfare",
      "placeholder": "Travel Fare Limit"
    },
    domProps: {
      "value": (_vm.form.travelfare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "travelfare", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "travelfare"
    }
  })], 1)]), _vm._v(" "), _vm._m(39)])])]), _vm._v(" "), _c('offerletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "reportingmanager": _vm.form.reportingmanager,
      "annualctc": _vm.form.annualctc,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('appointmentlettercontract', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "travelfare": _vm.form.travelfare,
      "reportingmanager": _vm.form.reportingmanager,
      "consultancyfees": _vm.form.consultancyfees,
      "contracttenure": _vm.form.contracttenure,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('appointmentletterpermanent', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "monthlygrosssalary": _vm.form.monthlygrosssalary,
      "reportingmanager": _vm.form.reportingmanager,
      "consultancyfees": _vm.form.consultancyfees,
      "contracttenure": _vm.form.contracttenure,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('confirmationletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "probationPeriodStartDate": _vm.form.probationPeriodStartDate,
      "probationPeriodEndDate": _vm.form.probationPeriodEndDate,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('experienceletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "periodStartDate": _vm.form.periodStartDate,
      "periodEndDate": _vm.form.periodEndDate,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('relievingletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "resignationDate": _vm.form.resignationDate,
      "lastDateOfEmployment": _vm.form.lastDateOfEmployment,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Offer Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name of Reporting Manager "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Annual CTC "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Offer Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Experience Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Period Start Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Period End Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Experience Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relieving Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Resignation Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Last Day of Employment "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Relieving Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Confirmation Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Probation Period Start Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Probation Period End Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Confirmation Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Appointment Letter Permanent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name of Reporting Manager "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contract Tenure "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Consultancy fees  "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Monthly Gross Salary  "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Appointment Letter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Appointment Letter Contract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name of Reporting Manager "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contract Tenure "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Consultancy fees  "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Travel Fare Limit  "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Appointment Letter")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa887f14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/HRM/PrintEmployeeLetter.vue
// module id = 810
// module chunks = 0